import { addNamespaceInOperations } from '../helper'
import { TYPE } from '@/services/connection'
import { MUTATIONS_METHODS } from './mutations'

export const ACTIONS_METHODS = {
  LOGIN: 'loginPlaka'
}

const loginPlaka = (connection, username, password) => {
  if (!connection.login) {
    throw new Error(`Not defined login in connection type 'connection.type'`)
  }
  return connection.login(username, password).then((data) => {
    return Promise.resolve(data)
  })
}

export const actions = {
  [ACTIONS_METHODS.LOGIN] ({ commit }, { connection = {}, username, password }) {
    return new Promise(async (resolve, reject) => {
      let user
      switch (connection.type) {
        case TYPE.PLAKA:
          user = await loginPlaka(connection, username, password)
          break
        default:
          reject(new Error(`Type '${connection.type}' is not a valid type`))
      }
      commit(MUTATIONS_METHODS.SET_USER, {
        id: connection.id,
        user: user
      })
      resolve(user)
    })
  }
}

export const ACTIONS = addNamespaceInOperations('user', ACTIONS_METHODS)
